<template>
  <b-container class="page-container" fluid>
    <BrandCheckout :combos="combos" :discount="discount"/>
  </b-container>
</template>
<style>

</style>

<script>
// @ is an alias to /src
import BrandCheckout from "@/components/checkout/brand/BrandCheckout.vue";

export default {
  title: 'Dropsmart Subscription Checkout',
  name: "Brand",
  components: {
    BrandCheckout
  },
  props: ["combos"],
  created() {
    this.discount = "14%";
  },
  data() {
    return {
      discount: null,
    };
  }

};
</script>
